import React, { Fragment, useContext, useEffect, useState, useRef } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { AlertContext } from "../../../context/AlertContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import Spinner from "./../Spinner";
import { AuthContext } from "../../../context/AuthContext";
import { Button } from "primereact/button";
import "../../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import ButtonMui from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { useNavigate } from "react-router-dom";
import Menu from "./../Menu";
import { MultiSelect } from "primereact/multiselect";
import { saveAs } from "file-saver";
import clienteAxios from "../../../config/axios";

const meses = [
  "Ene",
  "Feb",
  "Mar",
  "Abr",
  "May",
  "Jun",
  "Jul",
  "Ago",
  "Sep",
  "Oct",
  "Nov",
  "Dic",
];

const formatoImporte = (valor) =>
  Number(valor).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export default function ListadosCobranzasRealizadasAnual(props) {
  const [visibleFechas, setVisibleFechas] = useState(true);
  const [anio, setAnio] = useState(new Date().getFullYear());
  const [selectedCities, setSelectedCities] = useState([]);
  const [bandInicio, setBandInicio] = useState(false);

  const toast = useRef(null);

  let navigate = useNavigate();

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const { statusAcceso, empresaElegida, empresas, obtenerAcceso, obtenerEmpresas } =
    configuracionContext;

  useEffect(() => {
    if (state.usuario) {
      // Usa el mismo permiso que Cobranzas Realizadas
      obtenerAcceso({
        usuarioId: state.usuario.id,
        layout: "ListadosCobranzasRealizadas",
      });
    }
  }, [state.id]);

  useEffect(() => {
    obtenerEmpresas();
  }, []);

  const exitClick = (e) => {
    navigate("/");
  };

  const onHideFechas = (e) => {
    setVisibleFechas(false);
  };

  const aceptarFechas = async (exportType) => {
    //Validar

    if (!anio || anio < 2000 || anio > 2100) {
      mensajeAlerta(
        "Listados de Cobranzas Realizadas Anual",
        "Debe indicar un año válido !.",
        "error"
      );
      return;
    }

    if (selectedCities && selectedCities.length === 0) {
      mensajeAlerta(
        "Listados de Cobranzas Realizadas Anual",
        "Debe indicar al menos una empresa !.",
        "error"
      );
      return;
    }

    toast.current.show({
      severity: "info",
      summary: "Listados",
      detail: "Obteniendo información... !",
      life: 3000,
    });

    let data;
    try {
      const respuesta = await clienteAxios.post(
        "/api/configuracion/obtenercobranzasrealizadasanual",
        { anio, selectedCities }
      );
      data = respuesta.data;
    } catch (error) {
      console.log(error.response);
      mensajeAlerta(
        "Listados de Cobranzas Realizadas Anual",
        "Hubo un error al obtener la información !.",
        "error"
      );
      return;
    }

    if (!data || data.length === 0) {
      mensajeAlerta(
        "Listados de Cobranzas Realizadas Anual",
        "No hay cobranzas para el año indicado !.",
        "error"
      );
      return;
    }

    // Fila TOTAL
    let totalMeses = Array(12).fill(0);
    let totalGeneral = 0;
    for (let i = 0; i < data.length; i++) {
      for (let m = 0; m < 12; m++) {
        totalMeses[m] += data[i].meses[m];
      }
      totalGeneral += data[i].total;
    }
    const filas = [
      ...data,
      { grupo: "TOTAL", meses: totalMeses, total: totalGeneral },
    ];

    if (exportType === "excel") {
      exportExcel(filas);
    } else {
      exportPdf(filas);
    }
  };

  const textoEmpresas = () =>
    selectedCities.map((item) => item.nombre).join(" - ");

  const exportExcel = (filas) => {
    const listado = filas.map((fila) => {
      let row = { Grupo: fila.grupo };
      meses.forEach((mes, m) => {
        row[mes] = Number(fila.meses[m].toFixed(2));
      });
      row.Total = Number(fila.total.toFixed(2));
      return row;
    });

    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(listado);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      saveAs(
        blob,
        "cobranzasRealizadasAnual_" + anio + "_" + new Date().getTime() + ".xlsx"
      );
    });
  };

  const exportPdf = (filas) => {
    const columnas = [
      { title: "Grupo", dataKey: "grupo" },
      ...meses.map((mes, m) => ({ title: mes, dataKey: "m" + m })),
      { title: "Total", dataKey: "total" },
    ];

    const body = filas.map((fila) => {
      let row = { grupo: fila.grupo, total: formatoImporte(fila.total) };
      for (let m = 0; m < 12; m++) {
        row["m" + m] = formatoImporte(fila.meses[m]);
      }
      return row;
    });

    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default("l");
        doc.setFontSize(12);
        doc.text("Planilla de Cobranzas Realizadas", 10, 10);
        doc.setFontSize(8);
        doc.text(`Empresas: ${textoEmpresas()}`, 10, 16);
        doc.text(`Año: ${anio}`, 10, 21);

        let columnStyles = {};
        for (let c = 1; c <= 13; c++) {
          columnStyles[c] = { halign: "right" };
        }

        doc.autoTable(columnas, body, {
          margin: { left: 5, right: 5 },
          startY: 26,
          styles: {
            fontSize: 6,
          },
          columnStyles,
          didParseCell: (data) => {
            if (data.cell && data.cell.section === "head") {
              data.cell.styles.halign =
                data.column.index === 0 ? "left" : "right";
            }
            if (
              data.cell &&
              data.cell.section === "body" &&
              data.row.index === body.length - 1
            ) {
              data.cell.styles.fontStyle = "bold";
            }
          },
        });
        window.open(doc.output("bloburl"));
      });
    });
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Listados de Cobranzas Realizadas Anual",
      "No tiene permiso para acceder a esta pantalla !.",
      "error"
    );
    exitClick();
    return;
  };

  const renderHeaderFechas = () => {
    return (
      <div>
        <Tag value="Listado de Cobranzas Realizadas Anual"></Tag>
      </div>
    );
  };

  const renderFooterFechas = () => {
    return (
      <div>
        <Button
          icon="pi pi-file-excel"
          onClick={(e) => {
            aceptarFechas("excel");
          }}
          className="p-button-raised p-button-success"
          data-pr-tooltip="XLS"
          label="Excel"
        />
        <Button
          icon="pi pi-file-pdf"
          onClick={(e) => {
            aceptarFechas("pdf");
          }}
          className="p-button-raised p-button-warning"
          data-pr-tooltip="PDF"
          style={{ marginRight: "1em" }}
          label="PDF"
        />
        <ButtonMui
          onClick={onHideFechas}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  // INICIO

  if (!bandInicio && empresas && empresas.length > 0 && empresaElegida) {
    setBandInicio(true);
    const index = empresas.findIndex((item) => item.id === empresaElegida.id);
    if (index !== -1) {
      let final = [];
      final.push(empresas[index]);
      setSelectedCities(final);
    }
  }

  // FIN

  return (
    <Fragment>
      <Menu />
      <Toast ref={toast} />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <Fragment>
          <Dialog
            header={renderHeaderFechas()}
            visible={visibleFechas}
            closable={false}
            footer={renderFooterFechas()}
            breakpoints={{ "960px": "90vw" }}
            style={{ width: "90vw", paddingBottom: "0" }}
            position="top"
          >
            <Grid container spacing={3} style={{ marginTop: "1vw" }}>
              <Grid item xs={12} md={2}>
                <TextField
                  id="anio"
                  label="Año"
                  type="number"
                  variant="standard"
                  fullWidth
                  value={anio ? anio : ""}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    setAnio(e.target.value ? Number(e.target.value) : null);
                  }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                md={12}
                style={{ paddingLeft: "1vw", marginTop: "1vw" }}
              >
                <label htmlFor="id">Empresas</label>

                <MultiSelect
                  value={selectedCities}
                  onChange={(e) => setSelectedCities(e.value)}
                  options={
                    empresas ? empresas.filter((item) => item.habilitado) : null
                  }
                  optionLabel="nombre"
                  placeholder="Seleccione las empresas"
                  maxSelectedLabels={10}
                  display="chip"
                  style={{ marginLeft: "1vw" }}
                />
              </Grid>
            </Grid>
          </Dialog>
        </Fragment>
      ) : null}
      <Grid item xs={12} sm={12}></Grid>
    </Fragment>
  );
}
